import type { VerificationResultView } from "@exploitlens/ui-contracts";

export function VerificationResult({ result }: { result: VerificationResultView }) {
  return (
    <div
      className={[
        "rounded border p-4",
        result.ok ? "border-preserved bg-preserved-surface" : "border-loss bg-loss-surface",
      ].join(" ")}
    >
      <div className="flex items-center justify-between gap-3">
        <p className="text-sm font-medium text-ink">{result.label}</p>
        <span
          className={`flex items-center gap-1.5 text-sm font-medium ${result.ok ? "text-preserved" : "text-loss"}`}
        >
          <span aria-hidden="true">{result.ok ? "✓" : "✕"}</span>
          {result.ok ? "Verified" : "Failed"}
        </span>
      </div>
      <p className="mt-1 font-evidence text-xs text-ink-muted">{result.bundleDir}</p>

      {result.issues.length > 0 && (
        <ul className="mt-3 space-y-1.5 text-sm">
          {result.issues.map((issue, i) => (
            <li key={i} className="rounded border border-rule bg-canvas px-3 py-2">
              <span className="text-xs uppercase tracking-wide text-ink-faint">{issue.check}</span>
              <span className="ml-2 font-evidence text-xs text-ink-muted">{issue.path}</span>
              <p className="mt-1 text-ink">{issue.message}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
